import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { PrimaryButton } from "@/components/StandardButton";
import { useNavigate } from "react-router-dom";

export const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };
    
    const handleScroll = () => {
      // Show earlier on mobile (200px) for better conversion
      const threshold = isMobile ? 200 : 400;
      setIsVisible(window.scrollY > threshold);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile, { passive: true });
    window.addEventListener("scroll", handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener("resize", checkMobile);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Respect reduced motion preference
  const prefersReducedMotion = typeof window !== "undefined" 
    ? window.matchMedia("(prefers-reduced-motion: reduce)").matches 
    : false;

  if (!isVisible) return null;

  return (
    <div
      className={`fixed z-50 ${
        isMobile 
          ? "bottom-4 left-4 right-4 pb-safe" 
          : "bottom-6 right-6"
      } ${prefersReducedMotion ? "" : "animate-fade-in"}`}
    >
      <PrimaryButton
        size="lg"
        className={`gap-2 min-h-[52px] touch-manipulation ${
          isMobile 
            ? "w-full justify-center text-base font-semibold" 
            : ""
        }`}
        onClick={() => navigate("/auth?mode=signup")}
      >
        Start Free Trial
        <ArrowRight className="h-4 w-4" />
      </PrimaryButton>
    </div>
  );
};
